import React from "react";
import { func, node, string, number, oneOfType } from "prop-types";
import classNames from "classnames";

const GridTableContainer = ({
    children,
    className,
    columns,
    rows,
    columnsTemplate,
    rowsTemplate,
    renderAs: Component,
    ...props
}) => {
    const cols = columns !== 0 ? columns : children.length;

    const columnTemplate =
        // eslint-disable-next-line no-nested-ternary
        columnsTemplate === "auto"
            ? `repeat(${cols}, minmax(auto, 1fr))`
            : columnsTemplate === "fixed"
            ? `repeat(${cols}, 1fr)`
            : columnsTemplate;

    return (
        <Component
            className={classNames("grid-table-row", className)}
            style={{
                gridTemplateColumns: columnTemplate,
                gridTemplateRows:
                    rowsTemplate !== "" &&
                    (rowsTemplate === "auto" ? `repeat(${rows}, minmax(auto, 1fr));` : rowsTemplate),
            }}
            {...props}>
            {children}
        </Component>
    );
};

GridTableContainer.propTypes = {
    children: node.isRequired,
    className: string,
    columns: number,
    rows: number,
    columnsTemplate: string,
    rowsTemplate: string,
    renderAs: oneOfType([func, string]),
};

GridTableContainer.defaultProps = {
    className: "",
    columns: 0,
    rows: 1,
    columnsTemplate: "",
    rowsTemplate: "",
    renderAs: "div",
};

export default GridTableContainer;
